function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */

import { ContextActionUtils } from '@deephaven/components';
import { KeyHandler } from '@deephaven/grid';
import IrisGridUtils from "../IrisGridUtils.js";
class CopyKeyHandler extends KeyHandler {
  constructor(irisGrid) {
    super();
    _defineProperty(this, "irisGrid", void 0);
    this.irisGrid = irisGrid;
  }
  onDown(event) {
    var selectedRanges = this.irisGrid.state.selectedRanges;
    if (event.key === 'c' && ContextActionUtils.isModifierKeyDown(event)) {
      if (IrisGridUtils.isValidSnapshotRanges(selectedRanges)) {
        this.irisGrid.copyRanges(selectedRanges);
      } else {
        this.irisGrid.copyRanges(selectedRanges, false, false, 'Invalid copy ranges');
      }
      return true;
    }
    return false;
  }
}
export default CopyKeyHandler;
//# sourceMappingURL=CopyKeyHandler.js.map